var _path, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGb(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 16,
    viewBox: "0 0 23 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4920_5841)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4920_5841",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 23,
    height: 16
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.42 0H2.28665C1.10845 0 0.15332 0.955126 0.15332 2.13333V13.8667C0.15332 15.0449 1.10845 16 2.28665 16H20.42C21.5982 16 22.5533 15.0449 22.5533 13.8667V2.13333C22.5533 0.955126 21.5982 0 20.42 0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4920_5841)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.42 0H2.28665C1.10845 0 0.15332 0.955126 0.15332 2.13333V13.8667C0.15332 15.0449 1.10845 16 2.28665 16H20.42C21.5982 16 22.5533 15.0449 22.5533 13.8667V2.13333C22.5533 0.955126 21.5982 0 20.42 0Z",
    fill: "#22438B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.91355 -0.102539L-0.046875 0.245447L-0.0157393 2.60936L20.7265 16.037L22.76 15.7713L22.7145 13.4218L1.91355 -0.102539Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.1819 0.214844L-0.015625 1.41237L21.5398 15.7827L22.7373 14.5851L1.1819 0.214844Z",
    fill: "#C7152A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.6209 -0.0371094H23.016V2.35794C23.016 2.35794 8.39235 11.6738 2.1269 16.0233C2.05146 16.0759 0.0083701 15.8197 0.0083701 15.8197L-0.177246 13.5432L20.6209 -0.0371094Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.5913 0.181641L22.7373 1.4127L1.1819 15.783L-0.015625 14.5855L21.5913 0.181641Z",
    fill: "#C7152A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.36704 -0.0595703H14.3547V5.00465H22.7373V10.9923H14.3547V16.3359H8.36704V10.9923H-0.015625V5.00465H8.36704V-0.0595703Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.56457 -0.673828H13.1571V6.20268H22.7373V9.79525H13.1571V16.4644H9.56457V9.79525H-0.015625V6.20268H9.56457V-0.673828Z",
    fill: "#C7152A"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4920_5841"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22.4,
    height: 16,
    fill: "white",
    transform: "translate(0.15332)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGb);
export default __webpack_public_path__ + "static/media/GB.047e64d940ad0e7c76ef0bee8a76a9cd.svg";
export { ForwardRef as ReactComponent };